// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3854":"6513b02fe4dc36c7","8827":"ffe26fe731584f3c"}[chunkId] + ".css";
};